import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { FiBell } from 'react-icons/fi';
import styles from './bodywon.module.css';

const notificationPreferences = [
  { id: 1, title: 'Enable notifications for this site', description: 'As a Partner, you can easily enable or disable all notifications for each site. These changes only affect this site and your account.', hasIcon: true },
  { id: 2, title: 'Enable desktop notifications', description: "Never miss an important update. Get push notifications on your web browser, even when you're not visiting the site.", hasIcon: true },
  { id: 3, title: 'Dashboard', description: "Choose which notifications you'd like to receive on your Dashboard.", hasIcon: false },
  { id: 4, title: 'Email', description: "Choose which notifications you'd like to receive to your email.", hasIcon: false },
];

const NotificationModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className={styles.notificationModal}>
      <Modal.Header closeButton>
        <Modal.Title className={styles.notificationModalTitle}>
          Notification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notificationPreferences.map(item => (
          <div key={item.id} className={styles.preferenceCard}>
            <Row className="align-items-center">
              {item.hasIcon && (
                <Col xs="auto">
                  <div className={styles.preferenceIcon}>
                    <FiBell size={24} />
                  </div>
                </Col>
              )}
              <Col>
                <div className={styles.preferenceContent}>
                  <h5 className={styles.preferenceTitle}>{item.title}</h5>
                  <p className={styles.preferenceDescription}>{item.description}</p>
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default NotificationModal;
